import * as React from 'react';

export const CloseIcon = (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2.66666 13.3332L13.3333 2.6665' stroke='#656B6F' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M2.66666 2.6665L13.3333 13.3332' stroke='#656B6F' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
